import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, tokens, Text, Button } from '@fluentui/react-components';
import { Heading, Container } from '../../theme/primitives';
import { iconMap } from '../../theme/icons';

const ChevronLeftIcon = iconMap.chevron_left;
const ChevronRightIcon = iconMap.chevron_right;

const useStyles = makeStyles({
  wrap: {
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    paddingTop: '3rem',
    paddingBottom: '3rem',
    '@media (min-width: 1024px)': { paddingLeft: '3rem', paddingRight: '3rem' },
  },
  title: {
    textAlign: 'center',
    marginBottom: tokens.spacingVerticalXXXL,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalL,
    maxWidth: '42rem',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  // Realus Fluent <Button appearance="outline" shape="circular"> jau
  // suteikia aukštį/kraštus/hover pagal Fluent2 standartą (žr. #5).
  navButton: { flexShrink: 0 },
  navIcon: { fontSize: '18px' },
  content: { textAlign: 'center', flex: 1 },
  quote: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    lineHeight: '1.625',
    fontStyle: 'italic',
    margin: 0,
    '@media (min-width: 640px)': { fontSize: tokens.fontSizeBase400 },
  },
  meta: { marginTop: tokens.spacingVerticalL },
  author: { fontWeight: tokens.fontWeightSemibold, color: tokens.colorNeutralForeground1 },
  type: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase300 },
});

const Testimonials = () => {
  const s = useStyles();
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const reviews = t('shop.testimonials.reviews', { returnObjects: true });
  const review = reviews[index];

  const prev = () => setIndex(i => (i === 0 ? reviews.length - 1 : i - 1));
  const next = () => setIndex(i => (i === reviews.length - 1 ? 0 : i + 1));

  return (
    <Container size="xl" className={s.wrap}>
      <Heading as="h2" variant="h3" className={s.title}>{t('shop.testimonials.title')}</Heading>
      <div className={s.row}>
        <Button
          appearance="outline"
          shape="circular"
          onClick={prev}
          aria-label={t('shop.testimonials.prev')}
          icon={<ChevronLeftIcon className={s.navIcon} />}
          className={s.navButton}
        />

        <div className={s.content}>
          <Text as="p" className={s.quote}>"{review.text}"</Text>
          <Text as="p" className={s.meta}>
            <span className={s.author}>{review.author}</span>
            <span className={s.type}> · {review.type}</span>
          </Text>
        </div>

        <Button
          appearance="outline"
          shape="circular"
          onClick={next}
          aria-label={t('shop.testimonials.next')}
          icon={<ChevronRightIcon className={s.navIcon} />}
          className={s.navButton}
        />
      </div>
    </Container>
  );
};

export default Testimonials;
